// generated by recipeyak.api.base.codegen
import { http } from "@/apiClient"

export function calendarGenerateLink() {
  return http<{
    syncEnabled: boolean
    calendarLink: string
  }>({
    url: "/api/v1/calendar/generate_link/",
    method: "post",
  })
}
